import { useEffect, useState } from "react";
import { limitToLast, onValue, query, ref } from "firebase/database";
import { database } from "../../firebase/firebase";

interface IHistoryEntry {
  id: string;
  value: string;
  user?: string;
  postedAt?: number;
}

function formatAbsolute(ts?: number) {
  if (!ts) return "";
  try {
    return new Date(ts).toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

export function Log() {
  const [entries, setEntries] = useState<IHistoryEntry[] | null>(null);

  useEffect(() => {
    const q = query(ref(database, "history"), limitToLast(100));
    const unsub = onValue(q, (snapshot) => {
      const next: IHistoryEntry[] = [];
      snapshot.forEach((child) => {
        const v = child.val() ?? {};
        next.push({
          id: child.key ?? "",
          value: v.value ?? "",
          user: v.user ?? undefined,
          postedAt: typeof v.postedAt === "number" ? v.postedAt : undefined,
        });
        return false;
      });
      next.sort((a, b) => (b.postedAt ?? 0) - (a.postedAt ?? 0));
      setEntries(next);
    });
    return () => unsub();
  }, []);

  const total = entries?.length ?? 0;

  return (
    <main className="stage stage-scroll">
      <div className="wrap">
        <header className="page-head">
          <span className="page-kicker">the record</span>
          <h1 className="page-title">
            everything that<br />
            <em>came before.</em>
          </h1>
          <p className="page-sub">
            each phrase lived here until somebody replaced it
          </p>
        </header>

        {entries == null && <p className="log-empty">loading…</p>}
        {entries != null && entries.length === 0 && (
          <p className="log-empty">nothing replaced yet.</p>
        )}

        {entries != null && entries.length > 0 && (
          <ol className="log-list">
            {entries.map((e, i) => (
              <li
                key={e.id}
                className="log-row"
                style={{ ["--d" as any]: i } as React.CSSProperties}
              >
                <span className="log-idx">
                  {String(total - i).padStart(3, "0")}
                </span>
                <div className="log-main">
                  <div className="log-value">{e.value || "—"}</div>
                  <div className="log-meta">
                    {e.user ? (
                      <b>{e.user.toLowerCase()}</b>
                    ) : (
                      <span className="anon">anonymous</span>
                    )}
                    <span className="dot" aria-hidden />
                    <time className="when">{formatAbsolute(e.postedAt)}</time>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        )}
      </div>
    </main>
  );
}
